import { SITEPLAN_PAGE_URL, IFRAME_CALLBACK_URL, QUICK_SEARCH_URL } from 'Routes/constants';

export const routesConf = {
  agencyPickYourRoom: {
    baseUrl: '/agency/pick-your-room',
  },
  resortPickYourRoom: {
    baseUrl: '/resort/pick-your-room',
  },
  account: {
    baseUrl: '/account',
  },
  bookings: {
    baseUrl: '/account/bookings/:bookingId/stay/:stayId',
  },
  banking: {
    baseUrl: '/booking/banking',
  },
  confirmation: {
    baseUrl: '/confirmation',
  },
  contactInfo: {
    baseUrl: '/bi',
    args: ['proposalId'],
  },
  dashboard: {
    baseUrl: '/account/dashboard',
  },
  editorialArticle: {
    baseUrl: '/articles/:slug',
  },
  editorialTheme: {
    baseUrl: '/themes/:slug',
  },
  error: {
    baseUrl: '/error',
  },
  greatMembers: {
    baseUrl: '/great-members',
  },
  home: {
    baseUrl: '/',
  },
  newsletterConfirmation: {
    baseUrl: '/newsletter/c',
    args: [
      {
        name: 'type',
        restrict: {
          subscription: 's',
          management: 'm',
        },
      },
    ],
  },
  newsletterSubscription: {
    baseUrl: '/newsletter/s',
  },
  newsletterUnsubscription: {
    baseUrl: '/newsletter/u',
    args: ['subscriptionId'],
  },
  offer: {
    baseUrl: '/o',
    args: ['offerName'],
  },
  pastTrips: {
    baseUrl: '/account/past-trips',
  },
  futureTrips: {
    baseUrl: '/account/future-trips',
  },
  pax: {
    baseUrl: '/pax',
  },
  paxConfirmation: {
    baseUrl: '/paxConfirmation',
  },
  payment: {
    baseUrl: '/pi',
    args: ['proposalId'],
  },
  paymentConfirmation: {
    baseUrl: '/account/bookings/:bookingId/payment-confirmation',
  },
  paymentNotification: {
    baseUrl: '/payment-notification',
    args: ['paymentId', 'locale'],
  },
  paymentRedirect: {
    baseUrl: '/payment-redirect',
  },
  pickYourRoom: {
    baseUrl: '/account/prepare-my-stay/pick-your-room',
    args: ['bookingId'],
  },
  prepareMyStay: {
    baseUrl: '/account/prepare-my-stay/:bookingId/stay/:stayId',
  },
  prePayment: {
    baseUrl: '/pre-payment',
  },
  profile: {
    baseUrl: '/account/profile',
  },
  search: {
    baseUrl: '/s',
  },
  searches: {
    baseUrl: '/account/searches',
  },
  siteplan: {
    baseUrl: SITEPLAN_PAGE_URL,
  },
  activateAccount: {
    baseUrl: '/activateAccount',
  },
  signout: {
    baseUrl: '/signout',
  },
  stepup: {
    baseUrl: '/stepup',
  },
  sponsorship: {
    baseUrl: '/account/sponsorship',
  },
  optionConfirmation: {
    baseUrl: '/option/c',
    args: ['status'],
  },
  optionConfirmationError: {
    baseUrl: '/option-error/c',
    args: ['status', 'error_code'],
  },
  iframeCallback: {
    baseUrl: IFRAME_CALLBACK_URL,
  },
  booking: {
    baseUrl: '/booking',
    args: ['page'],
  },
  fragments: {
    baseUrl: '/fragments/:fragment',
  },
  comparator: {
    baseUrl: '/comparator',
  },
  prebookingformSuccessSeller: {
    baseUrl: '/prebookingform/success-seller',
  },
  quickSearch: {
    baseUrl: QUICK_SEARCH_URL,
  },
  proposalPdf: {
    baseUrl: '/proposal-pdf/:proposalId',
  },
};
